<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <table class="table table-hover table-mail">
      <spinner v-if="showSpinner" />
      <thead class="table-head">
        <tr>
          <th>PARQUÍMETRO</th>
          <th>STATUS</th>
          <th>NÍVEL DE BATERIA</th>
        </tr>
      </thead>
      <tbody class="table-list">
        <tr v-for="(parkingMeter, key) in parkingMeterList" :key="key">
          <td>{{ parkingMeter.fullName }}</td>
          <td>{{ parkingMeter.accountEnabled ? 'ATIVO' : 'INATIVO' }}</td>
          <td>
            {{ parkingMeter.device.batteryStatus || 'Indisponível' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import Spinner from '@/components/Spinner';
export default {
  components: { Spinner },
  data() {
    return {
      parkingMeterList: [],
    };
  },
  mounted() {
    this.getParkingMeterList();
  },
  methods: {
    async getParkingMeterList() {
      try {
        this.showSpinner = true;
        const response = await this.$store.dispatch('REPORTS/ParkingMeters');
        this.parkingMeterList = response.data;
      } catch (error) {
        this.$toasted.error('Falha ao carregar relatório.');
      } finally {
        this.showSpinner = false;
      }
    },
  },
};
</script>